import reducer, { initialState } from './dashboard';
import { actionCreators, DashboardActionType } from './dashboard.actionCreators';
import * as actionTypes from './dashboard.actionTypes';

export * from './dashboard';
export * from './dashboard.selectors';
export type ActionType = DashboardActionType;
export { actionTypes, actionCreators, initialState };
export default reducer;
